import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import {
  OrganizationSettingsAddMemberInstitutionModel,
  OrganizationSettingsAddMemberModel,
} from './organization-settings-add-member.model';
import { RolaReprezentantaOrganizacji } from '../../../../../shared/enums/rola-reprezentanta-organizacji.enum';
import {
  InstytucjaOrganizacja,
  Organizacja,
} from '../../../../../shared/models/organizacja';
import { CustomValidatorsBeneficiaryDetails } from '../../../../../shared/components/beneficiary/form-beneficiary-details/validators/custom-validators-beneficiary-details';

export class OrganizationSettingsAddMemberFormBuilder {
  public static createFormGroup(
    organizacja: Organizacja,
  ): FormGroup<OrganizationSettingsAddMemberModel> {
    const fg = new FormGroup<OrganizationSettingsAddMemberModel>({
      email: new FormControl({ value: null, disabled: true }, [
        Validators.required,
        Validators.email,
      ]),
      pesel: new FormControl(null, [
        Validators.required,
        CustomValidatorsBeneficiaryDetails.peselValid,
      ]),
      rola: new FormControl<RolaReprezentantaOrganizacji | null>(null, {
        validators: [Validators.required],
      }),
      instytucje: new FormArray<
        FormGroup<OrganizationSettingsAddMemberInstitutionModel>
      >([]),
    });

    organizacja.listaInstytucji?.forEach((value: InstytucjaOrganizacja) => {
      fg.controls.instytucje.push(
        OrganizationSettingsAddMemberFormBuilder.createInstytucjaFg(value),
      );
    });
    fg.setValidators(
      OrganizationSettingsAddMemberFormBuilder.atLeastOneInstitutionIfOupValidator,
    );
    return fg;
  }

  public static createInstytucjaFg(
    instytucja: InstytucjaOrganizacja,
  ): FormGroup<OrganizationSettingsAddMemberInstitutionModel> {
    return new FormGroup<OrganizationSettingsAddMemberInstitutionModel>({
      nazwa: new FormControl({ value: instytucja.nazwa, disabled: true }, [
        Validators.required,
      ]),
      identyfikator: new FormControl({
        value: instytucja.id,
        disabled: true,
      }),
      selected: new FormControl(false),
    });
  }

  private static atLeastOneInstitutionIfOupValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (!control) return null;
    const fg = control as FormGroup<OrganizationSettingsAddMemberModel>;

    const rola = fg.controls.rola.value;
    const instytucje = fg.controls.instytucje.value;

    if (rola !== RolaReprezentantaOrganizacji.OUP) {
      return null;
    }

    if (!instytucje || !Array.isArray(instytucje)) return null;

    const hasSelected = instytucje.some((i: any) => i.selected === true);

    return hasSelected ? null : { atLeastOneInstitutionRequired: true };
  }
}
